import IconButton from "app/components/IconButton";
import { CrossIcon } from "app/components/Icons";
import Input from "app/components/Input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import {
  selectSelectedProjectSetting,
  selectTagLoader,
} from "app/redux/selector";
import { actions } from "app/redux/slice";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toastService from "utils/toast";
import ColorPicker from "./ColorPicker";

interface AddNewTagProps {
  trigger?: React.ReactNode;
  className?: string;
  align?: "start" | "center" | "end";
  selectedColor: string;
  setSelectedColor: (val) => void;
}

const AddNew: React.FC<AddNewTagProps> = ({
  align,
  className,
  trigger,
  selectedColor,
  setSelectedColor,
}) => {
  const dispatch = useDispatch();
  const projectDetail = useSelector(selectSelectedProjectSetting);
  const loading = useSelector(selectTagLoader);
  const [value, setValue] = useState("");
  const [open, setOpen] = useState(false);

  const handleCreateTag = (tagValue: string, color: string) => {
    if (tagValue?.length === 0) {
      toastService?.error("please enter title");
    }

    const newTag = {
      title: tagValue,
      color: color,
      projectId: projectDetail[0]?._id,
    };
    dispatch(actions.createTagRequest({ data: newTag, callback: handleClose }));
  };
  const handleClose = () => {
    setValue("");
    setOpen(false);
  };
  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent
          align="start"
          alignOffset={30}
          className={`!px-0 !py-0 bg-white border border-[#E9ECF2] cursor-pointer`}
        >
          <Input
            id="value"
            name="value"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            style={{
              color: selectedColor,
            }}
            icon={
              <ColorPicker
                trigger={
                  <div
                    className={`border rounded-full flex justify-center items-center w-[20px] h-[20px] `}
                    style={{ borderColor: selectedColor }}
                  >
                    <div
                      className="w-[16px] h-[16px] rounded-full cursor-pointer"
                      style={{ background: selectedColor }}
                    />
                  </div>
                }
                selectedColor={selectedColor}
                updateCode={(val) => setSelectedColor(val)}
              />
            }
            endIcon={
              <div className="flex justify-end items-center gap-3">
                {value?.length > 0 && (
                  <IconButton
                    className="border-0"
                    onClick={() => handleCreateTag(value, selectedColor)}
                    disabled={value?.length === 0}
                    loading={loading}
                  />
                )}

                <button onClick={() => handleClose()} disabled={loading}>
                  <CrossIcon color="#79808A" />
                </button>
              </div>
            }
            maxLength={100}
          />
        </PopoverContent>
      </Popover>
    </>
  );
};

export default AddNew;
